import { SERVICE_OGP_IMAGE, SITE_URL } from '../../constants'
import { withFaqPageSchema } from '../../builders/faq'
import { buildServiceSchema } from '../../builders/service'
import { modernizationFaqItems } from '../../data/faqs/modernization'
import { PageMeta } from '../../types'

const description = "担当者不在・ドキュメント散逸のレガシーシステムも、生成AIによるコード解析で仕様を可視化し、安全に刷新します。ドキュメント整備・改修・クラウド移行・新アーキテクチャへの再構築まで、段階的に支援。E2Eテストでリリース後のリスクも最小化します。"

export const modernizationPageMeta: PageMeta = {
  title: "生成AIで加速するレガシーシステム刷新・モダナイゼーション支援 | i3DESIGN",
  description,
  keyword: "モダナイゼーション DX 生成AI E2Eテスト",
  image: SERVICE_OGP_IMAGE,
  url: `${SITE_URL}/services/modernization/`,
}

const modernizationServiceSchema = buildServiceSchema({
  slug: "modernization",
  name: "モダナイゼーション",
  description: modernizationPageMeta.description,
  serviceType: "モダナイゼーション",
  category: "モダンアプリケーション開発",
  offerCatalogName: "モダナイゼーションサービス",
  breadcrumbName: "モダナイゼーション",
  offers: [
    {
      name: "クラウドリフト",
      description: "既存資産を安全にクラウドへ移行し、業務を止めずにコストと運用負担を軽減します。また、安定性と効率性を確保したうえで次の変革ステップへ進む土台を築きます。",
    },
    {
      name: "クラウドシフト",
      description: "クラウド前提のアーキテクチャに刷新し、リアルタイム性と拡張性を獲得します。さらに、開発・運用の自動化基盤も構築し、継続的な改善と迅速なリリースを可能にします。",
    },
    {
      name: "AI駆動開発",
      description: "整備された基盤の上でAIを活用し、開発・運用・改善を自動化します。続いて内製化体制も整備し、持続的な競争優位と革新サイクルの確立を実現します。",
    }
  ],
})

export const modernizationSchema = withFaqPageSchema(
  modernizationServiceSchema,
  modernizationPageMeta.url,
  modernizationFaqItems,
)
